/**
 * Validators
 * Validation des formulaires.
 */

import { calculateDurationMinutes } from "./formatters.js";

// ─── User ───────────────────────────────────────────────────────

export function validateUserForm(formData) {
  const errors = {};

  if (!formData.first_name?.trim()) errors.first_name = "Le prénom est requis";
  if (!formData.last_name?.trim()) errors.last_name = "Le nom est requis";
  if (!formData.user_type)
    errors.user_type = "Le type d'utilisateur est requis";

  if (formData.email?.trim()) {
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email.trim()))
      errors.email = "L'adresse email n'est pas valide";
  }

  if (formData.phone?.trim()) {
    if (!/^[\d\s\-+().]+$/.test(formData.phone.trim()))
      errors.phone =
        "Le numéro de téléphone contient des caractères invalides";
  }

  return { isValid: Object.keys(errors).length === 0, errors };
}

// ─── Event ──────────────────────────────────────────────────────

export function validateEventForm(formData) {
  const errors = {};

  if (!formData.event_date) errors.event_date = "La date est requise";
  if (!formData.start_time && !formData.is_all_day)
    errors.start_time = "L'heure de début est requise";
  if (!formData.end_time && !formData.is_all_day)
    errors.end_time = "L'heure de fin est requise";
  if (!formData.event_type)
    errors.event_type = "Le type d'événement est requis";
  if (!formData.slot_status) errors.slot_status = "Le statut est requis";

  if (!formData.is_all_day && formData.start_time && formData.end_time) {
    if (calculateDurationMinutes(formData.start_time, formData.end_time) <= 0)
      errors.end_time = "L'heure de fin doit être après l'heure de début";
  }

  return { isValid: Object.keys(errors).length === 0, errors };
}

// ─── Recurrence ─────────────────────────────────────────────────

export function validateRecurrenceForm(formData) {
  const errors = {};

  if (!formData.frequency) errors.frequency = "La fréquence est requise";

  if (formData.interval !== undefined) {
    const val = Number(formData.interval);
    if (!Number.isInteger(val) || val < 1)
      errors.interval = "L'intervalle doit être un nombre entier >= 1";
  }

  return { isValid: Object.keys(errors).length === 0, errors };
}

// ─── Slot ───────────────────────────────────────────────────────

export function validateSlotForm(formData) {
  const errors = {};

  if (!formData.slot_date) errors.slot_date = "La date est requise";
  if (!formData.event_id) errors.event_id = "L'événement est requis";
  if (!formData.slot_status) errors.slot_status = "Le statut est requis";

  if (!formData.is_all_day) {
    if (!formData.start_time)
      errors.start_time = "L'heure de début est requise";
    if (!formData.end_time) errors.end_time = "L'heure de fin est requise";

    if (formData.start_time && formData.end_time) {
      if (
        calculateDurationMinutes(formData.start_time, formData.end_time) <= 0
      )
        errors.end_time = "L'heure de fin doit être après l'heure de début";
    }
  }

  return { isValid: Object.keys(errors).length === 0, errors };
}
